/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// React State
import { useState } from 'react';
// Components
import InfoHero from '../../components/heros/information';
import Button from '../../components/buttons/secondary';
import Plan from '../../components/plans/game';
import Footer from '../../components/footer';
import Reviews from '../../components/sections/reviews';

const All = () => {
    const gameServers = [
        { name: "minecraft", category: 2, price: "1.00", link: "/games/minecraft", linkType: "route", className: "bg-minecraft", active: true },
        { name: "ark", category: 3, price: "2.50", link: "/games/ark", linkType: "route", className: "bg-ark", active: true },
        { name: "rust", category: 3, price: "2.50", link: "/games/rust", linkType: "route", className: "bg-rust", active: false },
        { name: "arma", category: 4, price: "0.50", link: "/games/arma", linkType: "route", className: "bg-arma", active: false },
        { name: "valheim", category: 4, price: "2.25", link: "/games/valheim", linkType: "route", className: "bg-valheim", active: true },
        { name: "csgo", category: 2, price: "0.50", link: "/games/csgo", linkType: "route", className: "bg-csgo", active: false },
        { name: "garrysmod", category: 2, price: "0.50", link: "/games/garrys-mod", linkType: "route", className: "bg-garrysmod", active: true },
        { name: "hytale", category: 4, price: "0.50", link: "/games/hytale", linkType: "route", className: "bg-hytale", active: false }
    ]
    const [activeCategory, updateCategory] = useState(1);

    return (
        <main>
            <InfoHero title='Game Servers' description='View all of the Game Servers we offer.' />
            <section className='games py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                <div className='primary-gradient px-6 sm:px-6 md:px-6 lg:px-16 rounded-xl pt-16 pb-28'>
                    <div className='header mb-16'>
                        <ul className='flex flex-wrap'>
                            <li className='cursor-pointer select-none text-gray-300 hover:text-gray-200 hover:underline text-xl font-semibold mr-7' onClick={() => updateCategory(1)}>
                                All
                            </li>
                            <li className='cursor-pointer select-none text-gray-300 hover:text-gray-200 hover:underline text-xl font-semibold mr-7' onClick={() => updateCategory(2)}>
                                Popular
                            </li>
                            <li className='cursor-pointer select-none text-gray-300 hover:text-gray-200 hover:underline text-xl font-semibold mr-7' onClick={() => updateCategory(3)}>
                                Survival
                            </li>
                            <li className='cursor-pointer select-none text-gray-300 hover:text-gray-200 hover:underline text-xl font-semibold mr-7' onClick={() => updateCategory(4)}>
                                Featured
                            </li>
                        </ul>
                    </div>
                    <div className='body'>
                        <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-x-8 gap-y-16'>
                            {activeCategory === 1 ? gameServers.map(server => <Plan price={server.price} priceType={server.priceType} link={server.link} linkType={server.linkType} className={server.className} active={server.active} />) : gameServers.map(server => server.category === activeCategory ? <Plan price={server.price} priceType={server.priceType} link={server.link} linkType={server.linkType} className={server.className} active={server.active} /> : null)}
                        </div>
                    </div>
                </div>
            </section>
            <Reviews />
            <Footer />
        </main>
    )
}

export default All